<template>
  <div class="dialogLx">
    <el-container>
      <el-card class="left">
        <div class="btn">
          <h-button type="primary" @click="add()">新建</h-button>
          <h-button type="success" @click="deit()" :disabled="isok === 0"
            >编辑</h-button
          >
          <h-button type="danger" @click="del()" :disabled="isok === 0"
            >删除</h-button
          >
        </div>
        <div class="filelist">
          <ul>
            <li
              v-for="(item, index) in typelist"
              :key="index"
              class="file"
              @click="change(item, index)"
              :class="{ active: index === isok }"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </el-card>
      <el-card class="right">
        <component
          :isok="isok"
          :itemRow="itemRow"
          :is="componentId"
          ref="offlinefileRef"
          :typelist="typelist"
        ></component>
      </el-card>
    </el-container>
  </div>
  <el-dialog
    v-model="dialogVisible"
    :title="states === 1 ? '添加' : '修改'"
    width="20%"
  >
    <el-input v-model="form.name"></el-input>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="filegroupAxios">确定</h-button>
        <h-button @click="dialogVisible = false">取消</h-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import offlinefile from "@/views/smartApplication/videoAnalysis/components/offlinefile.vue";
import offlinefiletwo from "@/views/smartApplication/videoAnalysis/components/offlinefiletwo.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  getlistbycondition,
  filegroup,
  filegroupdelete,
  filegroupPut
} from "@/api/videoAnalysis/videoAnalysisApi.js";
export default defineComponent({
  components: {
    offlinefiletwo,
    offlinefile
  },
  setup() {
    const state = reactive({
      componentId: "offlinefile",
      itemRow: {},
      isok: 0,
      dialogVisible: false,
      states: 1,
      form: {
        name: ""
      },
      typelist: [
        {
          name: "全部文件"
        }
      ]
    });
    const add = () => {
      state.dialogVisible = true;
      state.states = 1;
    };
    // 添加
    const filegroupAxios = async is => {
      let res;
      const from = JSON.parse(JSON.stringify(state.form));
      if (state.states === 1) {
        res = await filegroup(from);
      } else {
        from.id = state.typelist[state.isok].id;
        res = await filegroupPut(from);
      }
      if (res.code === 0) {
        ElMessage({
          type: "success",
          message: (state.states === 1 ? "添加" : "修改") + "成功"
        });
        state.dialogVisible = false;
      }
      getlistbyconditionAxios();
    };
    // 切换
    const change = (item, index) => {
      if (item.id) {
        state.componentId = "offlinefiletwo";
      } else {
        state.componentId = "offlinefile";
      }
      state.itemRow = item;
      // offlinefileRef
      state.isok = index;
    };
    // 左侧列表
    const getlistbyconditionAxios = async () => {
      state.typelist = [
        {
          name: "全部文件"
        }
      ];
      const res = await getlistbycondition();
      state.typelist = state.typelist.concat(res.list);
      console.log(res, 5555);
    };

    getlistbyconditionAxios();
    const deit = () => {
      state.dialogVisible = true;
      state.states = 2;
      state.form.name = state.typelist[state.isok].name;
    };
    const del = async () => {
      if (state.isok === 1) {
        ElMessage({
          type: "warning",
          message: "该分组为初始默认分组，无法删除"
        });
        return;
      }
      ElMessageBox.confirm("确定要删除选中数据吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(
        async () => {
          const params = {
            id: state.typelist[state.isok].id
          };
          const res = await filegroupdelete(params);
          if (res.code === 0) {
            ElMessage({
              type: "success",
              message: "删除成功"
            });
            getlistbyconditionAxios();
          }
        },
        () => {}
      );
    };
    return {
      ...toRefs(state),
      deit,
      del,
      change,
      filegroupAxios,
      add
    };
  }
});
</script>
<style scoped lang="scss">
.dialogLx {
  height: 70vh;
  .el-container {
    height: 100%;
    .left {
      height: 100%;
      width: 300px;
      :deep(.el-card__body) {
        display: flex;
        justify-content: flex-start;
      }
      .btn {
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 0;
      }
      .filelist {
        .file {
          line-height: 30px;
          cursor: pointer;
        }
        .filelist {
          .file {
            line-height: 30px;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      flex: 1;
      margin-left: 10px;
    }
  }
}
.active {
  line-height: 30px;
  cursor: pointer;
  background-color: #eef2ff;
  color: #7784ff;
}
</style>
